import z from "zod";
import EncodedCheckoutState from "../../../model/misc/EncodedCheckoutState";

export const orderDedicatedServerUrlParam = new EncodedCheckoutState(
  z.object({
    transactionId: z.string().uuid(),
    articleId: z.string().min(1),
    storageSizeInGiB: z
      .preprocess(
        (val) =>
          typeof val === "string"
            ? parseInt(val)
            : typeof val === "number"
              ? val
              : undefined,
        z.number(),
      )
      .innerType(),
    freeTrial: z.preprocess((val) => !!val, z.boolean()).innerType(),
    promotion: z.string().optional(),
    promotionDays: z.number().optional(),
  }),
);
